<template>
  <div>
    <div class="container homapt-section">
      <div class="container-fluid bottom-margin">
        <div class="row">
          <div class="col homapt-col-padding text-center">
            <h1 class="homapt-slide-right">Homes Made Easy</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 homapt-col-padding">
            <div class="container-fluid">
              <div class="row homapt-expandable">
                <div id="first-hme" class="col-xl-6 text-center">
                  <img src="/static/Cart.Icon.svg" class="homapt-hme-icon" alt="something">
                </div>
                <div class="col-xl-6 text-center">
                  <h3>Buying</h3>
                  <p>
                    How much is your HomApt Reward? With the HomApt reward program, you can save
                    <router-link class="link" to="/rebates">thousands*</router-link>
                    by purchasing your home with a HomApt Realtor.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 homapt-col-padding">
            <div class="container-fluid">
              <div class="row homapt-expandable">
                <div class="col-xl-6 text-center">
                  <img src="/static/House$.Icon.svg" class="homapt-hme-icon" alt="something">
                </div>
                <div class="col-xl-6 text-center">
                  <h3>Selling</h3>
                  <p>Ready to sell? HomApt's full-service agents will provide the experience you need.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 homapt-col-padding">
            <div class="container-fluid">
              <div class="row homapt-expandable">
                <div class="col-xl-6 text-center">
                  <img src="/static/Tools.Icon.svg" class="homapt-hme-icon" alt="something">
                </div>
                <div class="col-xl-6 text-center">
                  <h3>Maintenance</h3>
                  <p>HomApt Realty has a network of local professionals who can provide advice and help keep your home looking beautiful.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 homapt-col-padding">
            <div class="container-fluid">
              <div class="row homapt-expandable">
                <div class="col-xl-6 text-center">
                  <img src="/static/Arrows.Icon.svg" class="homapt-hme-icon" alt="something">
                </div>
                <div class="col-xl-6 text-center">
                  <h3>Improvement</h3>
                  <p>Want it done right? General Contractors are available to update your home and make it yours!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reward-section bottom-margin">
      <div class="container">
        <!--<div class="row reward-row">
          <div class="col text-center">
            <h3>You could save thousands on your closing costs with the <router-link to="savetimemoney">HomApt Reward Program!</router-link></h3>
          </div>
        </div>
        <div class="row reward-row">
          <div class="col">
            <p>When buying a home with HomApt Realty, we give you part of our commission! Based on the purchase price of your home, you will receive money at closing from HomApt Realty to assist with any associated costs. You could save thousands on your closing costs!</p>
          </div>
        </div>
        <div class="row reward-row">
          <div class="col text-center">
            <h5><router-link to="savetimemoney">HomApt Buyer Savings*</router-link></h5>
            <p>${{ buyerSavings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col text-center my-auto">
            <h5>House Price</h5>
            <p>${{ value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col text-center">
            <h5>HomApt Seller Savings*</h5>
            <p>${{ sellerSavings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
        <div class="row reward-row">
          <div class="col-8 offset-2 text-center">
            <div class="form-group">
              <input type="range" class="form-control-range" id="formControlRange" min="100000" max="3000000" step="1000" v-model="value">
            </div>
          </div>
        </div>
        <div class="row reward-row">
          <div class="col">
            <p>*Savings and Rewards listed are estimates and subject to change. Not all states or mortgage programs allow for you to claim a refund, contact a HomApt Realtor or your lender for more information. A minimum commission applies, see <router-link to="/rebates">terms and conditions</router-link>.</p>
          </div>
        </div>-->
        <div class="row reward-row">
          <div class="col text-center">
            <h3>Let's Get Started Today!</h3>
            <router-link to="/contact">
              <button class="btn btn-primary contact-us-button">Contact Us</button>
            </router-link>
          </div>
        </div>
        <div class="row reward-row">
          <div class="col">
            <p>Find out more about what HomApt agents can do for you. With no obligation, our experienced Agents will contact you within the hour to discuss your time line, needs and next steps. Why wait? Contact us today!</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container homapt-section bottom-margin">
      <div class="row">
        <div class="col-sm text-center">
          <h1 class="third-section-title">We Empower You</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 text-center homapt-col-padding">
          <div class="card homapt-expandable homapt-home-card outside-card">
            <div id="first-card" class="card-body">
              <img src="../../../assets/timemoney.png" class="homapt-hme-icon" alt="something" height='200px'>
              <h3 class="card-title overlay-text">Save Time and Money</h3>
              <p class="card-text overlay-text">With access to all of your home needs in one place, we can save you time and money on the home ownership process.</p>
              <div class="btn-wrapper">
                <b-button class="learn-more-button" variant="primary" to='/savetimemoney'>Learn More</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 text-center homapt-col-padding">
          <div class="card homapt-expandable homapt-home-card">
            <div class="card-body">
              <img src="../../../assets/clipboard.png" class="homapt-hme-icon" alt="something" height='200px'>
              <h3 class="card-title overlay-text">Transparency</h3>
              <p class="card-text overlay-text">We have nothing to hide! Dispense with the legal jargon and get the answers you want. HomApt Realtors make it easy for you!</p>
              <b-button class="learn-more-button" variant="primary" to='/profsupport'>Learn More</b-button>
            </div>
          </div>
        </div>
        <div class="col-lg-4 text-center homapt-col-padding">
          <div class="card homapt-expandable homapt-home-card outside-card">
            <div class="card-body">
              <img src="../../../assets/guy.png" class="homapt-hme-icon" alt="something" height='200px'>
              <h3 class="card-title overlay-text">Professional Support</h3>
              <p class="card-text overlay-text">Sometimes you just need to talk to a person! We have licensed professionals readily available to help answer your questions.</p>
              <b-button class="learn-more-button" variant="primary" to='/profsupport'>Learn More</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-us" v-bind:style="aboutUs">
      <div class="dark-overlay">
        <div class="container-fluid h-100">
          <div class="row h-100">
            <div class="col-md-8 offset-md-2 my-auto">
              <h2 class="about-us-text">About Us</h2>
              <p class="about-us-text">As a start-up real estate tech firm, we are bringing together professional home services and real estate experts to simplify home ownership. We are passionate about streamlining the process, eliminating unnecessary fees and modernizing the user experience.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: 1000000
    }
  },
  computed: {
    buyerSavings () {
      if (this.value < 100000) return 100
      if (this.value <= 250000) return Math.round((this.value * 0.025) * 0.1)
      if (this.value <= 500000) return Math.round((this.value * 0.025) * 0.15)
      if (this.value >= 500000) return Math.round((this.value * 0.025) * 0.2)
    },
    sellerSavings () {
      return Math.round((this.value * 0.015))
    },
    aboutUs () {
      return 'background-image: url("https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xlarge/uploads/0Q7A5596.jpg")'
    }
  }
}
</script>

<style scoped>
.third-section-title {
  margin-bottom: 3rem;
}

.bottom-margin {
  margin-bottom: 6rem;
}

.contact-us-button {
  width: 300px !important;
}

.reward-row {
  padding-top: 1.5rem !important;
}

.reward-section {
  background-color: #e0e1e3;
  padding-bottom: 3rem;
  padding-top: 3rem;
}

.dark-overlay {
  background: rgba(0, 0, 0, .55) !important;
}

.about-us-text {
  color: white !important;
}

.about-us {
  margin-bottom: -10px;
  background-size: cover;
  background-position: center !important;
  background-repeat: no-repeat;
  margin-top: 2rem;
  height: 400px;
}

.card {
  height: 100%;
  border-radius: 12px;
}

.card-text {
  margin-bottom: 2.3rem;
}

.card-body {
  position: relative;
}

.card-title {
  padding-top: 1rem;
}

.learn-more-button {
  transform: scale(0.9);
  position: absolute;
  right: 0;
  bottom: 10px;
}

.link {
  color: #748096;
}

.link:hover {
  text-decoration: underline !important;
}

@media (max-width: 768px) {
  .homapt-hme-icon {
    transform: scale(0.7);
  }
}

.homapt-home-card {
  background-image: url("../../../assets/background.png");
  background-repeat: repeat;
}

.homapt-col-padding {
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/PropertySearchStatic.vue